const initialState = {
    agGridDefaultColDef: [],
    agGridDefaultColDefHistory: [],
    agGridRowData: [],
    agGridContextMenuItems: [],
    totalRowCount: -1,
    tableName: '',
    explorerViews: [],
    virtualColumns: [],
    filesFromServer: [],
    filesFromContainer: [],
    linkedGcDataArray: {}
};


export default initialState;

